import React from 'react';
import TableRowMaterial from '@material-ui/core/TableRow';

const TableRow = ({ children, ...rest }) => (
  <TableRowMaterial {...rest}>{children}</TableRowMaterial>
);

export default TableRow;
